var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'btn',
    {
      primaryBtn: _vm.stylevariant === 'primary',
      secondaryBtn: _vm.stylevariant === 'secondary',
      linkBtn: _vm.stylevariant === 'link',
      hardLink: _vm.stylevariant === 'hardlink'
    },
    {'nofocus' : !_vm.focusable } ],style:(_vm.cus_style),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._t("default"),(_vm.loading)?_c('base-spinner',{staticStyle:{"margin-left":"0.5rem"},attrs:{"size":"small"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }